const l=l=>null==l;export{l as default};
//# sourceMappingURL=isAbsent.js.map
